import React from 'react';

const TelegramCircleIcon = () => (
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.5067 23.6808C18.9539 23.6808 24.1803 18.4543 24.1803 12.0072C24.1803 5.55998 18.9539 0.333496 12.5067 0.333496C6.05949 0.333496 0.833008 5.55998 0.833008 12.0072C0.833008 18.4543 6.05949 23.6808 12.5067 23.6808Z"
      fill="#34AADF"
    />
    <path
      d="M5.83771 11.7512C5.83771 11.7512 11.6202 9.29107 13.6257 8.42482C14.3945 8.07834 17.0017 6.96953 17.0017 6.96953C17.0017 6.96953 18.205 6.48447 18.1047 7.66253C18.0713 8.14764 17.8039 9.84543 17.5365 11.6819C17.1354 14.2806 16.7008 17.1218 16.7008 17.1218C16.7008 17.1218 16.634 17.9188 16.0658 18.0574C15.4976 18.196 14.5616 17.5723 14.3945 17.4337C14.2608 17.3297 11.8876 15.7705 11.0186 15.0082C10.7846 14.8003 10.5172 14.3846 11.052 13.8994C12.2553 12.756 13.6926 11.3354 14.5616 10.4345C14.9627 10.0187 15.3638 9.04852 13.6926 10.2266C11.3194 11.9244 8.97966 13.5183 8.97966 13.5183C8.97966 13.5183 8.44485 13.8648 7.44211 13.5529C6.43932 13.2411 5.26945 12.8253 5.26945 12.8253C5.26945 12.8253 4.46729 12.3056 5.83771 11.7512Z"
      fill="white"
    />
  </svg>
);

export default TelegramCircleIcon;
